import { useEffect } from 'react';
import { platformAPI, fileUrl } from '../../services/api';

/**
 * Silently fetches the platform favicon from settings and updates the <link rel="icon"> tag.
 * Render once at the top of the app.
 */
export default function FaviconLoader() {
  useEffect(() => {
    platformAPI.getPublicSettings().then(data => {
      if (data.favicon_path) {
        // Update every favicon link (svg, png sizes, apple-touch)
        document.querySelectorAll("link[rel*='icon'], link[rel='apple-touch-icon']")
          .forEach(link => { link.href = fileUrl(data.favicon_path); });
        // Ensure an apple-touch-icon exists even if the template lacked one
        if (!document.querySelector("link[rel='apple-touch-icon']")) {
          const link = document.createElement('link');
          link.rel = 'apple-touch-icon';
          link.href = fileUrl(data.favicon_path);
          document.head.appendChild(link);
        }
      }
    }).catch(() => {});
  }, []);
  return null;
}
